var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-exclamation",
    clipPath: "url(#clip0_1188_4258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5225 2.75C15.1083 2.75 17.5883 3.77723 19.4168 5.60571C21.2452 7.43419 22.2725 9.91414 22.2725 12.5C22.2725 15.0859 21.2452 17.5658 19.4168 19.3943C17.5883 21.2228 15.1083 22.25 12.5225 22.25C9.9366 22.25 7.45665 21.2228 5.62817 19.3943C3.79969 17.5658 2.77246 15.0859 2.77246 12.5C2.77246 9.91414 3.79969 7.43419 5.62817 5.60571C7.45665 3.77723 9.9366 2.75 12.5225 2.75ZM12.5225 24.5C15.7051 24.5 18.7573 23.2357 21.0077 20.9853C23.2582 18.7348 24.5225 15.6826 24.5225 12.5C24.5225 9.3174 23.2582 6.26516 21.0077 4.01472C18.7573 1.76428 15.7051 0.5 12.5225 0.5C9.33986 0.5 6.28762 1.76428 4.03718 4.01472C1.78674 6.26516 0.522461 9.3174 0.522461 12.5C0.522461 15.6826 1.78674 18.7348 4.03718 20.9853C6.28762 23.2357 9.33986 24.5 12.5225 24.5ZM12.5225 6.5C11.899 6.5 11.3975 7.00156 11.3975 7.625V12.875C11.3975 13.4984 11.899 14 12.5225 14C13.1459 14 13.6475 13.4984 13.6475 12.875V7.625C13.6475 7.00156 13.1459 6.5 12.5225 6.5ZM14.0225 17C14.0225 16.6022 13.8644 16.2206 13.5831 15.9393C13.3018 15.658 12.9203 15.5 12.5225 15.5C12.1246 15.5 11.7431 15.658 11.4618 15.9393C11.1805 16.2206 11.0225 16.6022 11.0225 17C11.0225 17.3978 11.1805 17.7794 11.4618 18.0607C11.7431 18.342 12.1246 18.5 12.5225 18.5C12.9203 18.5 13.3018 18.342 13.5831 18.0607C13.8644 17.7794 14.0225 17.3978 14.0225 17Z",
    fill: "#DB2828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_4258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.522461 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamation);
export default __webpack_public_path__ + "static/media/circle-exclamation.53ec90caaf2c1eafe8c8b6735f1ae70f.svg";
export { ForwardRef as ReactComponent };